import { render, staticRenderFns } from "./HotelsAdvancedDetailHistory.vue?vue&type=template&id=1f977644&"
import script from "./HotelsAdvancedDetailHistory.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports